import { IsUUID } from 'class-validator';

import { SourceDto } from './source.dto';

export class StatusDto {
  @IsUUID()
  uuid!: string;

  sources: SourceDto[];

  constructor(sources: SourceDto[]) {
    this.sources = sources;
  }
}
